import React from 'react';
import { Navigation } from 'lucide-react';
import { googleMapsUrl, wazeUrl } from './driver/driverUtils';
import { addrLine } from './travel/TravelLegs';

const pill = 'h-8 px-2.5 rounded-full border text-[11px] font-black inline-flex items-center gap-1 bg-white shrink-0';

export const AddressLinks = ({ job, side, label }) => {
  const line = addrLine(job, side);
  if (!line) return null;
  const id = `${side}-${job.ref}`;
  return (
    <div className="space-y-1" data-testid={`addr-${id}`}>
      <div className="text-xs text-slate-700"><span className="font-bold">{label}:</span> {line}</div>
      <div className="flex gap-1.5">
      <a href={googleMapsUrl(null, line)} target="_blank" rel="noreferrer" className={`${pill} border-slate-200 text-blue-700 hover:border-blue-500`} data-testid={`addr-google-${id}`}><Navigation className="w-3 h-3" />Google Maps</a>
      <a href={wazeUrl(line)} target="_blank" rel="noreferrer" className={`${pill} border-slate-200 text-sky-700 hover:border-sky-400`} data-testid={`addr-waze-${id}`}>Waze</a>
      </div>
    </div>
  );
};

export const JobAddressLinks = ({ job, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    <AddressLinks job={job} side="from" label="From" />
    <AddressLinks job={job} side="to" label="To" />
  </div>
);
